import { Box, Center, Flex, Icon, Text, TextProps } from '@chakra-ui/react'
import React from 'react'
import { IconType } from 'react-icons'

interface Props {
    icon: IconType
    label: string
    value: string
    valueProps?: TextProps
    helpText?: React.ReactNode
    helpTextProps?: TextProps
    tag?: React.ReactNode
    color?: string
}

const PendingActionDetail: React.FC<Props> = ({
    icon,
    label,
    value,
    valueProps,
    helpText,
    tag,
    helpTextProps,
    color = 'gray.400',
}) => {
    return (
        <Flex align="center" gap={3}>
            <Center bg={color} rounded="full" p={2}>
                <Icon as={icon} color="white" boxSize="16px" />
            </Center>
            <Box>
                <Flex mb={-0.5} gap={1}>
                    <Text fontSize="xs" fontWeight="semibold" color="gray.700">
                        {label}
                    </Text>
                    {tag && <Box fontSize="sm">{tag}</Box>}
                </Flex>
                <Text fontSize="sm" {...valueProps}>
                    {value}
                </Text>
                {helpText && (
                    <Text
                        mt={-0.5}
                        fontSize="xs"
                        color="gray.500"
                        {...helpTextProps}
                    >
                        {helpText}
                    </Text>
                )}
            </Box>
        </Flex>
    )
}

export default PendingActionDetail
